import request from '@/utils/request'

// 类型表

let FormApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.form/index', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.form/edit', data, errorback);
    },
}

export default FormApi;



// WEBPACK FOOTER //
// ./src/api/study/form.js